import { ADMIN_SIDEBAR } from './adminSidebar'

// Finance Manager has full admin access EXCEPT the Settings section. Rather than
// duplicate the whole admin sidebar (and let it drift), derive from it and strip
// only the Settings title + its link. Route access is enforced separately: the
// role is admin-equivalent in access.js ROLE_GROUPS, and /settings is blocked by
// requiresPermission: 'manage_settings' in router/index.js.
export const FINANCE_MANAGER_SIDEBAR = ADMIN_SIDEBAR.filter((item) => {
  const isSettingsTitle = item.slug === 'title' && item.name === 'Settings'
  const isSettingsLink = item.slug === 'link' && item.href === '/settings'
  return !isSettingsTitle && !isSettingsLink
})
